import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // Import Tailwind CSS
import App from "./App";
import AppRegistrationForm from "./AppRegistrationForm";

const rootElement = document.getElementById("root");
const formElement = document.getElementById("formular"); // Updated to match the ID in index.html

if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
} else if (formElement) {
    const formRoot = ReactDOM.createRoot(formElement);
    formRoot.render(
        <React.StrictMode>
            <AppRegistrationForm />
        </React.StrictMode>
    );
}
